import React, { createContext, useCallback, useContext, useMemo } from "react";

import { Context } from "./types/context";
import useCheckboxState from "common/hooks/useCheckboxState";
import { useGetFilter } from "features/myFleet/store";
import { useMyFleetOperations } from "features/myFleet/hooks";

interface Props {
  children: React.ReactNode;
}

export const FilterContext = createContext({} as Context);
export const useFilterContext = () => useContext(FilterContext);

const FilterProvider = ({ children }: Props) => {
  const filter = useGetFilter();
  const { resetFilter } = useMyFleetOperations();
  const [locationStatus, onChangeLocationStatus, setLocationFilter] =
    useCheckboxState(filter.locationStatus);
  const [deviceType, onChangeDeviceType, setDeviceTypeFilter] =
    useCheckboxState(filter.deviceType);

  const resetFilterContext = useCallback(() => {
    setLocationFilter({});
    setDeviceTypeFilter({});

    resetFilter();
  }, [resetFilter, setLocationFilter, setDeviceTypeFilter]);

  const value = useMemo(
    () => ({
      locationStatus,
      onChangeLocationStatus,
      resetFilter: resetFilterContext,
      deviceType,
      onChangeDeviceType,
    }),
    [
      locationStatus,
      deviceType,
      onChangeLocationStatus,
      onChangeDeviceType,
      resetFilterContext,
    ]
  );

  return (
    <FilterContext.Provider value={value}>{children}</FilterContext.Provider>
  );
};

export default FilterProvider;
